module.exports = __webpack_public_path__ + "img/28.6.CODm.d8a3431a.png";